import {connect} from '@modifi/redux'

import TasksList, {TasksListProps} from './TasksList'
import {selectAllTasks} from '../../../../../data/tasks'

const mapStateToProps = (state: Record<string, any>): Pick<TasksListProps, 'tasks'> => ({
  tasks: selectAllTasks(state),
})

export default connect(mapStateToProps, null)(TasksList)
